<script setup lang="ts">

import OTPInput from "@/components/inputs/OTPInput.vue";
import ButtonInput from "@/components/inputs/Button.vue";
import Translator from '@/utils/common/Translator'
import {computed, onBeforeUnmount, onMounted, ref} from "vue";
import {useErrorsStore} from "@/stores/ToastDataStore.ts";

const props = defineProps<{ otpLength?: number, resendDelay?: number }>();
let otp = ref("");
let emit = defineEmits(['confirmOTPClicked', 'resendOTPClicked']);
let timeLeftInSeconds = ref(props.resendDelay ?? 60);
let timer: any = null;
let counterString = computed(() => {
  const minutes = Math.floor(timeLeftInSeconds.value / 60);
  const seconds = timeLeftInSeconds.value % 60;
  return `${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;
});

function startCounter() {
  timer = setInterval(() => {
    timeLeftInSeconds.value--;
    if (timeLeftInSeconds.value === 0) {
      clearInterval(timer!);
    }
  }, 1000);
}

onMounted(() => {
  startCounter();
});

onBeforeUnmount(() => {
  clearInterval(timer!);
});

function onApplyClick() {
  if (!validateOTP()) {
    useErrorsStore().pushErrorStr("OTP -" + otp.value + "- is not valid");
    return;
  }
  emit('confirmOTPClicked', otp.value);
}

function onResendOTPClicked() {
  timeLeftInSeconds.value = props.resendDelay ?? 60;
  startCounter();
  emit('resendOTPClicked');
}

function validateOTP() {
  return otp.value && otp.value.length === props.otpLength;
}
</script>

<template>
  <div class="tw-flex tw-flex-1 tw-items-center tw-justify-center tw-px-6 tw-py-10 mobile:tw-px-5 mobile:tw-py-8">
    <div class="tw-w-full tw-max-w-[380px]">
      <h2 class="tw-m-0 tw-text-3xl tw-font-medium tw-text-namaFontColor-input-light dark:tw-text-namaFontColor-input-dark mobile:tw-text-2xl"
          v-text="Translator.translateId('otpCheckYouMessages')"/>
      <div class="tw-mb-7"></div>
      <OTPInput v-model="otp" :length="otpLength" @onApplyClick="onApplyClick" class="tw-mb-5"/>
      <ButtonInput class="nama-auth-cta" :text="Translator.translateId('Confirm')" @click="onApplyClick"/>
      <div class="tw-mt-3 tw-text-center tw-text-sm">
        <span class="tw-text-namaFontColor-header-light dark:tw-text-namaFontColor-header-dark"
              v-if="timeLeftInSeconds > 0">{{ counterString }}</span>&nbsp;
        <a v-if="timeLeftInSeconds===0" href="#"
           class="tw-text-primary-light dark:tw-text-primary-dark hover:tw-underline"
           @click.prevent="onResendOTPClicked">{{ Translator.translateId("sendAnotherCode?") }}</a>
        <span v-else-if="timeLeftInSeconds > 0"
              class="tw-text-namaFontColor-header-light dark:tw-text-namaFontColor-header-dark tw-opacity-60">{{
            Translator.translateId("sendAnotherCode?")
          }}</span>
      </div>
    </div>
  </div>
</template>

<style scoped>
</style>
